import React from 'react';
import { useTranslation } from 'react-i18next';

export interface IosPaymentIssuePopupProps {
  open: boolean;
  onClose: () => void;
  onNotifyMe: () => void;
}

const IosPaymentIssuePopup: React.FC<IosPaymentIssuePopupProps> = ({
  open,
  onClose,
  onNotifyMe,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ios-payment-issue-title"
    >
      <div
        className="bg-white rounded-2xl shadow-xl max-w-sm w-full overflow-hidden"
        style={{ direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr' }}
      >
        <div className="px-6 pt-6 pb-2 text-center">
          <h2 id="ios-payment-issue-title" className="text-xl font-bold text-gray-900 mb-2">
            {t('payments_ios_issue_title')}
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed">{t('payments_ios_issue_message')}</p>
        </div>
        <div className="flex flex-col gap-2.5 px-6 pb-6 pt-4">
          <button
            type="button"
            onClick={onNotifyMe}
            className="w-full py-3 px-4 rounded-xl font-semibold text-white transition opacity hover:opacity-90"
            style={{ backgroundColor: '#1A1A2E' }}
          >
            {t('payments_ios_issue_notify_me')}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="w-full py-3 px-4 rounded-xl font-semibold text-gray-700 border border-gray-300 transition hover:bg-gray-50"
          >
            {t('payments_ios_issue_no_thanks')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default IosPaymentIssuePopup;
